export const DEFAULT_WRF = 3.0;
export const DEFAULT_FFL = 16.0;
export const DEFAULT_SLOPE = 0.0;
export const DEFAULT_BOM_DF = 1;

export const FFDI_COLORS = {
  scale: {
    '12': 'rgba(122, 193, 66, 0.7)',
    '25': 'rgba(0, 174, 239, 0.7)',
    '35': 'rgba(250, 253, 159, 0.7)',
    '50': 'rgba(255, 240, 0, 0.7)',
    '75': 'rgba(248, 152, 41, 0.7)',
    '100': 'rgba(238, 46, 36, 0.7)'
  },
  else: 'rgba(133, 12, 6, 0.7)'
};

export const FH_COLORS = {
  scale: {
    '1.5': 'rgba(122, 193, 66, 0.7)',
    '4': 'rgba(248, 152, 41, 0.7)'
  },
  else: 'rgba(238, 46, 36, 0.7)'
};



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/mcarthur_mk5/constants.js